import { ReactElement } from 'react';

import { Box, InputBase, InputBaseProps } from '@mui/material';
import { NumericFormat } from 'react-number-format';

import useChargeInputValidation from 'src/hooks/useChargeInputValidation';
import useFieldErrorHandler from 'src/hooks/useFieldErrorHandler';

interface ChargeInputProps extends InputBaseProps {
    label?: string;
    currency?: string;
    percentage?: boolean;
    min?: number;
    max?: number;
    endAdornment?: ReactElement;
    startAdornment?: ReactElement;
}
export const ChargeInput = ({
    placeholder,
    name,
    disabled = false,
    min,
    max,
    endAdornment,
    startAdornment,
}: ChargeInputProps) => {
    const { finalErrors, hasError, addError, clearErrors } = useFieldErrorHandler({
        fieldName: name,
        config: {
            autoSyncToForm: true,
            autoCleanup: true,
        },
    });

    const {
        shouldRenderEmptyBox,
        field,
        displayError,
        errorMessage,
        handleCurrencyChange,
        handleBlurCurrency,
    } = useChargeInputValidation({
        name,
        min,
        max,
        finalErrors,
        hasError,
        addError,
        clearErrors,
    });

    if (shouldRenderEmptyBox) {
        // add blank space to align boxes to correct column
        return <Box display="flex" flexDirection="column" sx={{ height: '100%', width: '100%' }} />;
    }

    return (
        <Box display="flex" flexDirection="column" sx={{ height: '100%', width: '100%' }}>
            <NumericFormat
                name={name}
                value={field.value}
                defaultValue={0.0}
                onChange={handleCurrencyChange}
                onBlur={handleBlurCurrency}
                decimalSeparator="."
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator
                customInput={InputBase}
                placeholder={placeholder}
                autoComplete="off"
                className={`form-input ${displayError ? 'input-error' : ''}`}
                disabled={disabled}
                endAdornment={endAdornment}
                startAdornment={startAdornment}
                style={{
                    height: '100%',
                }}
            />
            {!disabled && displayError ? (
                <label
                    className="input-base-field-error"
                    style={{
                        wordWrap: 'break-word',
                        maxWidth: '100%',
                        display: 'flex',
                        position: 'relative',
                        bottom: 0,
                    }}
                >
                    {/* Display an error message for value out of range */}
                    {errorMessage}
                </label>
            ) : null}
        </Box>
    );
};

export { InputBase };
